var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button max-width-full w-button",attrs:{"disabled":_vm.loading}},[(_vm.loading)?_c('svg',{staticClass:"spinner",attrs:{"viewBox":"0 0 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"25","cy":"25","r":"20","fill":"none","stroke-width":"5"}})]):_vm._e(),(!_vm.loading)?_c('span',[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }